import { useReadonlyContext } from "../../context/read-only.context";

export default function ReadonlyWrapper({ children }: { children: React.ReactNode }) {
  const { readonly } = useReadonlyContext();

  if (readonly) return;

  return children;
}